export default __webpack_public_path__ + "static/media/launch.852aae6a.png";